const spacing = {
  pageGutter: '5%',
  sectionSpacing: '40px',
  elementGap: '20px',
  tightGap: '10px',
};

export default spacing;
